<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">区域管理</div>
        <div style="text-align: right; margin-bottom: 10px">
          <el-button @click="onAdd">新 增</el-button>
        </div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView
            ref="regionMap"
            MapKey="DefaultMap"
            MapLayers=" "
            @onAreaDrawn="onAreaDrawn"
          ></MapView>
          <div class="map_search_panel">
            <div>
              <el-table
                v-loading="loading"
                :data="tableData"
                ref="multipleTable"
                border
                style="width: 100%"
                height="100%"
                fixed
                @row-click="handleRowClick"
              >
                <el-table-column
                  prop="RegionNo"
                  label="区域编号"
                ></el-table-column>
                <el-table-column
                  prop="RegionName"
                  label="区域名称"
                ></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <template>
                      <el-button
                        @click.native.stop="editDetail(scope.row)"
                        type="text"
                        size="small"
                        >编辑</el-button
                      >
                      <el-button
                        @click.native.stop="
                          deleteClick(scope.$index, scope.row)
                        "
                        type="text"
                        size="small"
                        >删除</el-button
                      >
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
    <div>
      <el-dialog
        title="区域管理"
        :visible.sync="dialogVisible"
        width="35%"
        :before-close="handleClose"
        :append-to-body="true"
        style="text-align: left"
        :destroy-on-close="true"
      >
        <ZjRegionManagerInfo
          @clickCancel="handleDialogCancel"
          :DrawRegionInfo="drawRegionInfo"
          :RegionInfo="regionInfo"
        ></ZjRegionManagerInfo>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MapView from "./components/RegionMapView";
import MyApis from "../../apis";
import ZjRegionManagerInfo from "./RegionManagerInfo";
import ZJApp from "../../../../app";

export default {
  name: "RegionManagerView",
  componentName: "RegionManagerView",
  components: {
    MapView,
    ZjRegionManagerInfo,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      loading: false,
      regionInfo: {},
      DrawRegionInfo: [],
    };
  },
  methods: {
    onAdd() {
      this.regionInfo = {};
      this.ClearOverlays();
      this.GetArea(ZJApp.ZJUtils.uuid());
    },
    onAreaDrawn: function(data) {
      this.drawRegionInfo = data;
      this.dialogVisible = true;
    },
    handleDialogCancel() {
      this.dialogVisible = false;
      this.search();
    },
    editDetail(row) {
      this.regionInfo = row;
      this.ClearOverlays();

      this.SetViewport(row);
      this.DrawPolygon(row);
      if (this.regionInfo.Areas == null || this.regionInfo.Areas.length < 2) {
        //清空所有遮盖物
        this.ClearOverlays();
        //启动多边形绘制功能
        this.GetArea(ZJApp.ZJUtils.uuid());
      } else {
        this.$refs.regionMap.mapInstance.tool.DrawingArea.hide();
        //启动多边形编辑功能
        this.EditPolygon(this.regionInfo);
      }
    },
    handleRowClick(row) {
      this.ClearOverlays();
      this.$refs.regionMap.mapInstance.tool.PolygonEditor.hide();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.hide();
      this.SetViewport(row);
      this.DrawPolygon(row);
    },
    search() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      this.loading = true;
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.RegionList()
            .DelRegion(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.ClearOverlays();
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //清空所有覆盖物
    ClearOverlays() {
      this.$refs.regionMap.mapInstance.clearAll();
    },
    //获取一个地图区域。（将启动多边形绘制功能）
    GetArea(id) {
      this.$refs.regionMap.mapInstance.tool.PolygonEditor.hide();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.hide();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.show();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.drawPolygon({
        id: id,
      });
    },
    EditPolygon(region) {
      if (region == null || region.Areas == null || region.Areas.length == 0)
        return;
      this.$refs.regionMap.mapInstance.tool.PolygonEditor.edit(region.RegionId);
    },
    SetViewport(region) {
      const points = region.Areas.map((item) => ({
        lng: item.Longitude,
        lat: item.Latitude,
      }));
      this.$refs.regionMap.mapInstance.setViewport(points);
    },
    DrawPolygon(region) {
      const points = region.Areas.map((item) => ({
        lng: item.Longitude,
        lat: item.Latitude,
      }));
      this.$refs.regionMap.mapInstance.drawPolygon(points, region.RegionId);
    },
  },
  mounted() {
    this.search();
    this.logInfo.ActionName = "区域查询";
    this.logInfo.LogMessage = "区域查询";
    this.logInfo.ModuleName = "设备管理";
    this.logInfo.PageName = "区域管理列表";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "RegionManagerView",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
